import React from "react";
import { Toaster } from "sonner";
import { useTheme } from "@/theme/ThemeProvider";

/**
 * Sonner toaster wired to the goSTOPS palette.
 * `richColors` is deliberately off: the default saturated red/green chips clash
 * with the warm-paper surfaces, so every severity uses our semantic tokens.
 */
export const BrandToaster = () => {
  const { theme } = useTheme();
  return (
    <Toaster
      position="bottom-right"
      theme={theme}
      closeButton
      visibleToasts={3}
      toastOptions={{
        classNames: {
          toast:
            "group !rounded-[var(--radius)] !border !border-border !bg-card !text-foreground !shadow-lg !font-sans",
          title: "!text-[13px] !font-semibold",
          description: "!text-[12px] !text-muted-foreground",
          actionButton:
            "!rounded-md !bg-primary !text-primary-foreground !text-[11px] !font-semibold",
          cancelButton:
            "!rounded-md !bg-secondary !text-secondary-foreground !text-[11px] !font-semibold",
          closeButton: "!border-border !bg-card !text-muted-foreground",
          success: "!border-success-border !bg-success-surface !text-success-text",
          error: "!border-danger-border !bg-danger-surface !text-danger-text",
          warning: "!border-warning-border !bg-warning-surface !text-warning-text",
          info: "!border-info-border !bg-info-surface !text-info-text",
        },
      }}
      data-testid="app-toaster"
    />
  );
};
